const state = {
    customVuexName: ''
};
const getters = {};
const actions = {};
const mutations = {
    setCustomVuexName(state, val) {
        state.customVuexName = val;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}